import haircareDiag from './code/Scripts/Components/haircareDiag.vue';

export default {
  components: {
    haircareDiag,
  },
};
